<script>
    import { getContext } from 'svelte';
    import EditSourceContainer from './container.svelte';
    import EditSourceForm from './content.svelte';
    export let feedSource;
    export let tagOptions;
  
    const { open, close } = getContext('simple-modal');
    const showPopup = (event) => {
        event.stopPropagation();
          open(EditSourceContainer,
            {
                message: "Source",
            },
            {
                // closeButton: CloseButton,
                form: EditSourceForm,
                propsForForm: [feedSource, tagOptions, close],
            }
        );
      };
</script>

<a
    href={'#'}
    class="edit-source-link" 
    on:click={showPopup}>
        Edit Source
</a>

<style>
    .edit-source-link {
        font-size: 14px;
    }
</style>